import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import { submitOrder } from '../../api'
import './OrderModal.css'

const OrderModal = ({ isOpen, onClose, serviceName }) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [isSent, setIsSent] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isOpen) return undefined

    setIsSent(false)
    setError('')
    document.body.style.overflow = 'hidden'

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.style.overflow = 'unset'
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setIsSubmitting(true)
    try {
      await submitOrder({ name, phone, serviceName })
      setIsSent(true)
      setTimeout(() => {
        onClose()
        setName('')
        setPhone('')
      }, 1600)
    } catch (err) {
      setError('Не удалось отправить заявку. Попробуйте ещё раз')
    } finally {
      setIsSubmitting(false)
    }
  }

  return createPortal(
    <div className="order-modal-overlay" onClick={onClose}>
      <div
        className="order-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Заказать услугу"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="order-modal__close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={22} strokeWidth={2} />
        </button>

        {isSent ? (
          <div className="order-modal__success">
            <h3>Заявка отправлена</h3>
            <p>Наш менеджер свяжется с вами в ближайшее время</p>
          </div>
        ) : (
          <>
            <h3 className="order-modal__title">Заказать услугу</h3>

            <form className="order-modal__form" onSubmit={handleSubmit}>
              <label className="order-modal__field">
                <span className="order-modal__label">Услуга</span>
                <input type="text" value={serviceName || ''} readOnly disabled />
              </label>

              <label className="order-modal__field">
                <span className="order-modal__label">Ваше имя</span>
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </label>

              <label className="order-modal__field">
                <span className="order-modal__label">Номер телефона</span>
                <input
                  type="tel"
                  name="phone"
                  autoComplete="tel"
                  required
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </label>

              {error && <p className="order-modal__error">{error}</p>}

              <button type="submit" className="order-modal__submit" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : 'Отправить заявку'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>,
    document.body
  )
}

export default OrderModal
